// extracted by mini-css-extract-plugin
export default {"leadersBlockHeader":"LeaderBlock_leadersBlockHeader__0zDb-","incomeCityTitle":"LeaderBlock_incomeCityTitle__3IJXt"};